/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableUserModelScreensManager} from '../../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';
import {RepeatableScreensManagerDeps} from '../../../../shared/step/repeatable-screen-manager.class';
import {DeaRegistrationService} from '../../../../../domain/model/licenses-certifications/dea/dea-registration.service';

@Injectable()
export class DeaRegistrationScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: DeaRegistrationService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/dea/dea-registration/dea-registration-screens-manager.service.ts